import { message } from "antd";
import axios from "axios";
import download from "downloadjs";

// Generate AI Filtered Image
export const generateTextPoster = (prompt) => async (dispatch) => {
    await axios
        .post(`/api/text_posters/generate_text_poster`, {
            prompt: prompt,
        })
        .then(async (response) => {
            dispatch({
                type: "GENERATE_TEXT_POSTER_SUCCESS",
                payload: response.data,
            });
        })
        .catch((error) => {
            message.error(error?.response?.data?.message, 5);
        });
};

// Download text poster
export const downloadTextPoster =
    (text_poster_uuid, format, resolution, size) => async (dispatch) => {
        await axios
            .get(
                `/api/text_posters/download/${text_poster_uuid}/${format}/${resolution}/${size}`,
                {
                    responseType: "arraybuffer",
                }
            )
            .then(async (response) => {
                await download(
                    response.data,
                    `img.${format}`,
                    `image/${format}`
                );
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Fetch user text posters
export const fetchUserTextPosters =
    (urlParams, offset, limit) => async (dispatch) => {
        var key = await urlParams.get("key");
        await axios
            .get(
                `/api/text_posters/user_text_posters/${key}/${offset}/${limit}`
            )
            .then(async (response) => {
                dispatch({
                    type: "FETCH_USER_TEXT_POSTERS_SUCCESS",
                    payload: response.data,
                    key: "user_text_posters" + "_" + urlParams.toString(),
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Fetch search result in poster gallery
export const fetchSearchPosters =
    (urlParams, offset, limit) => async (dispatch) => {
        var key = await urlParams.get("key");
        await axios
            .get(
                `/api/text_posters/search_text_posters/${key}/${offset}/${limit}`
            )
            .then(async (response) => {
                dispatch({
                    type: "FETCH_SEARCH_TEXT_POSTERS_SUCCESS",
                    payload: response.data,
                    key: "search_posters" + "_" + urlParams.toString(),
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };
